<button
  #trigger
  type="button"
  class="theme-trigger"
  aria-haspopup="true"
  [attr.aria-expanded]="popover.isOpen()"
  [attr.aria-controls]="popupId"
  [attr.aria-label]="'Theme: ' + current().label"
  (click)="toggle()">
  @switch (current().value) {
    @case ('light') {
      <svg class="theme-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2.5v2M12 19.5v2M4.6 4.6l1.4 1.4M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4L6 18M18 6l1.4-1.4" />
      </svg>
    }
    @case ('dark') {
      <svg class="theme-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <path d="M20.5 14.2A8.5 8.5 0 1 1 9.8 3.5a7 7 0 0 0 10.7 10.7z" />
      </svg>
    }
    @default {
      <svg class="theme-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <rect x="3" y="4" width="18" height="12.5" rx="2" />
        <path d="M8.5 20.5h7M12 16.5v4" />
      </svg>
    }
  }
  <!-- Every word sits in one grid cell, so the button is as wide as the longest. -->
  <span class="theme-words" aria-hidden="true">
    @for (choice of choices; track choice.value) {
      <span class="theme-word" [class.theme-word--current]="choice.value === current().value">{{ choice.label }}</span>
    }
  </span>
</button>

<ng-template #panel>
  <div class="theme-panel" role="radiogroup" aria-label="Theme" [id]="popupId" (keydown)="onGroupKeydown($event)">
    @for (choice of choices; track choice.value) {
      <button
        type="button"
        role="radio"
        class="theme-option"
        [attr.data-theme-value]="choice.value"
        [attr.aria-checked]="choice.value === current().value"
        [attr.tabindex]="choice.value === current().value ? 0 : -1"
        (click)="choose(choice.value)">
        <span [class]="'thumb thumb--' + choice.value" aria-hidden="true">
          @if (choice.value === 'system') {
            <span class="thumb-half thumb-half--light"></span>
            <span class="thumb-half thumb-half--dark"></span>
          }
        </span>
        <span class="theme-option-label">{{ choice.label }}</span>
      </button>
    }
  </div>
</ng-template>
